import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { color } from '@/colors';

export const Flex = styled('div')({
  display: 'flex',
});
Flex.displayName = 'Flex';

export const FlexCol = styled(Flex)({
  display: 'flex',
  flexDirection: 'column',
});
FlexCol.displayName = 'FlexCol';

export const FlexCenHor = styled(Flex)({
  justifyContent: 'center',
});
FlexCenHor.displayName = 'FlexCenHor';

export const FlexCenVer = styled(Flex)({
  alignItems: 'center',
});
FlexCenVer.displayName = 'FlexCenVer';

export const FlexCenVerSpaceBetween = styled(Flex)({
  alignItems: 'center',
  justifyContent: 'space-between',
});
FlexCenVerSpaceBetween.displayName = 'FlexCenVerSpaceBetween';

export const FlexCenHorVer = styled(FlexCenHor)({
  alignItems: 'center',
});
FlexCenHorVer.displayName = 'FlexCenHorVer';

export const FlexColCenHor = styled(FlexCol)({
  alignItems: 'center',
});
FlexColCenHor.displayName = 'FlexColCenHor';

export const FlexColCenVer = styled(FlexCol)({
  justifyContent: 'center',
});
FlexColCenVer.displayName = 'FlexColCenVer';

export const FlexColCenHorVer = styled(FlexColCenHor)({
  alignItems: 'center',
  justifyContent: 'center',
});
FlexColCenHorVer.displayName = 'FlexColCenHorVer';

export const AppPaper = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  backgroundColor: color.Black92,
  border: `1px solid ${color.White04_T}`,
}));
AppPaper.displayName = 'AppPaper';
